import { useRef, useMemo } from "react";
import { createPopper } from "@popperjs/core";
import useIsomorphicLayoutEffect from "../useIsomorphicLayoutEffect.es.js";
const usePopper = (options = {}) => {
  const referenceRef = useRef();
  const popperRef = useRef();
  const instanceRef = useRef();
  const combinedOptions = useMemo(() => {
    const { modifiers = [] } = options;
    return {
      ...options,
      modifiers: [...modifiers, { name: "preventOverflow", options: { padding: 8 } }]
    };
  }, [options]);
  useIsomorphicLayoutEffect(() => {
    const instance = createPopper(referenceRef.current, popperRef.current, combinedOptions);
    instanceRef.current = instance;
    return () => {
      instance.destroy();
    };
  }, [combinedOptions]);
  useIsomorphicLayoutEffect(() => {
    instanceRef.current.setOptions(combinedOptions);
    instanceRef.current.update();
  }, [combinedOptions]);
  return {
    reference: referenceRef,
    popper: popperRef,
    instance: instanceRef
  };
};
export {
  usePopper as default
};
//# sourceMappingURL=usePopper.es.js.map
